import { render, staticRenderFns } from "./Marker.vue?vue&type=template&id=634aa4a3&"
import script from "./Marker.vue?vue&type=script&lang=js&"
export * from "./Marker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports